import styled from 'styled-components'

export const Warning = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--gray100);
  border-radius: 16px;
  gap: 12px;
  height: var(--app-bar-height);
  width: 100%;
  padding: 24px;
`
